/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.

import React from 'react';
import Loadable from 'react-loadable';

const Accordion = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Accordion" */ '../components/Accordion').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Accordion'],
});


const AlwaysInMotion = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "AlwaysInMotion" */ '../components/AlwaysInMotion').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['AlwaysInMotion'],
});


const AnchorBar = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "AnchorBar" */ '../components/AnchorBar').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['AnchorBar'],
});


const ApplicationLegend = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ApplicationLegend" */ '../components/ApplicationLegend').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ApplicationLegend'],
});


const AppointmentFormModalPopup = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "AppointmentFormModalPopup" */ '../components/AppointmentFormModalPopup').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['AppointmentFormModalPopup'],
});


const AxleCards = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "AxleCards" */ '../components/AxleCards').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['AxleCards'],
});


const AxleCardsContainer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "AxleCardsContainer" */ '../components/AxleCardsContainer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['AxleCardsContainer'],
});


const Banner = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Banner" */ '../components/Banner').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Banner'],
});


const BannerWithAnimatedLeftSide = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "BannerWithAnimatedLeftSide" */ '../components/BannerWithAnimatedLeftSide').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['BannerWithAnimatedLeftSide'],
});


const BannerWithCards = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "BannerWithCards" */ '../components/BannerWithCards').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['BannerWithCards'],
});


const Breadcrumb = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Breadcrumb" */ '../components/Breadcrumb').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Breadcrumb'],
});


const CallUsList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CallUsList" */ '../components/CallUsList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CallUsList'],
});


const CardCompare = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CardCompare" */ '../components/CardCompare').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CardCompare'],
});


const CardContainer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CardContainer" */ '../components/CardContainer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CardContainer'],
});


const CardList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CardList" */ '../components/CardList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CardList'],
});


const CardProductWrapper = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CardProductWrapper" */ '../components/CardProductWrapper').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CardProductWrapper'],
});


const CardsPress = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CardsPress" */ '../components/CardsPress').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CardsPress'],
});


const Carousel = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Carousel" */ '../components/Carousel').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Carousel'],
});


const CarouselLazy = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CarouselLazy" */ '../components/CarouselLazy').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CarouselLazy'],
});


const CollaborationSlider = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Collaboration Slider" */ '../components/Collaboration Slider').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Collaboration Slider'],
});


const ContactModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ContactModule" */ '../components/ContactModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ContactModule'],
});


const ContactUsFormModalPopup = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ContactUsFormModalPopup" */ '../components/ContactUsFormModalPopup').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ContactUsFormModalPopup'],
});


const ContactUsTemplate = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ContactUsTemplate" */ '../components/ContactUsTemplate').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ContactUsTemplate'],
});


const CtaList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CtaList" */ '../components/CtaList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CtaList'],
});


const CustomSelect = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CustomSelect" */ '../components/CustomSelect').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CustomSelect'],
});


const CxContactUs = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CxContactUs" */ '../components/CxContactUs').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CxContactUs'],
});


const CxFormContainerModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CxFormContainerModule" */ '../components/CxFormContainerModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CxFormContainerModule'],
});


const CxSlider = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "CxSlider" */ '../components/CxSlider').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['CxSlider'],
});


const DealerLocatorChineseModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DealerLocatorChineseModule" */ '../components/DealerLocatorChineseModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DealerLocatorChineseModule'],
});


const DealerLocatorModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DealerLocatorModule" */ '../components/DealerLocatorModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DealerLocatorModule'],
});


const DescriptionWithSpecificationHighlights = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DescriptionWithSpecificationHighlights" */ '../components/DescriptionWithSpecificationHighlights').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DescriptionWithSpecificationHighlights'],
});


const Details = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Details" */ '../components/Details').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Details'],
});


const DoubleCtaList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DoubleCtaList" */ '../components/DoubleCtaList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DoubleCtaList'],
});


const DynamicCard = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DynamicCard" */ '../components/DynamicCard').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DynamicCard'],
});


const DynamicCardList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "DynamicCardList" */ '../components/DynamicCardList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['DynamicCardList'],
});


const EAxleModelContainer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "EAxleModelContainer" */ '../components/EAxleModelContainer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['EAxleModelContainer'],
});


const eAxleStage360Preview = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "eAxleStage360Preview" */ '../components/eAxleStage360Preview').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['eAxleStage360Preview'],
});


const EditorialView = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "EditorialView" */ '../components/EditorialView').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['EditorialView'],
});


const EDrivelinesSolutions = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "EDrivelinesSolutions" */ '../components/EDrivelinesSolutions').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['EDrivelinesSolutions'],
});


const EngineModelCards = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "EngineModelCards" */ '../components/EngineModelCards').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['EngineModelCards'],
});


const EngineSeries = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "EngineSeries" */ '../components/EngineSeries').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['EngineSeries'],
});


const FAQ = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "FAQ" */ '../components/FAQ').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['FAQ'],
});


const Filter = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Filter" */ '../components/Filter').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Filter'],
});


const Filternew = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Filter.new" */ '../components/Filter.new').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Filter.new'],
});


const FilterDetailPageStage = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "FilterDetailPageStage" */ '../components/FilterDetailPageStage').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['FilterDetailPageStage'],
});


const FindEngineTemplate = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "FindEngineTemplate" */ '../components/FindEngineTemplate').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['FindEngineTemplate'],
});


const FindYourEngine = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "FindYourEngine" */ '../components/FindYourEngine').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['FindYourEngine'],
});


const Footer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Footer" */ '../components/Footer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Footer'],
});


const Form = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Form" */ '../components/Form').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Form'],
});


const FormContainerModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "FormContainerModule" */ '../components/FormContainerModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['FormContainerModule'],
});


const GlobalPresenceNumbers = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "GlobalPresenceNumbers" */ '../components/GlobalPresenceNumbers').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['GlobalPresenceNumbers'],
});


const Header = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Header" */ '../components/Header').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Header'],
});


const HeaderOld = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "HeaderOld" */ '../components/HeaderOld').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['HeaderOld'],
});


const HeroBanner = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "HeroBanner" */ '../components/HeroBanner').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['HeroBanner'],
});


const History = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "History" */ '../components/History').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['History'],
});


const Homepage = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Homepage" */ '../components/Homepage').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Homepage'],
});


const Hotspot = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Hotspot" */ '../components/Hotspot').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Hotspot'],
});


const IconList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "IconList" */ '../components/IconList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['IconList'],
});


const Icons = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Icons" */ '../components/Icons').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Icons'],
});


const IFrameModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "IFrameModule" */ '../components/IFrameModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['IFrameModule'],
});


const ImageCtaList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ImageCtaList" */ '../components/ImageCtaList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ImageCtaList'],
});


const ImageGallery = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "ImageGallery" */ '../components/ImageGallery').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['ImageGallery'],
});


const InfiniteScroll = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "InfiniteScroll" */ '../components/InfiniteScroll').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['InfiniteScroll'],
});


const InnovationContainer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "InnovationContainer" */ '../components/InnovationContainer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['InnovationContainer'],
});


const IvecoForm = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "IvecoForm" */ '../components/IvecoForm').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['IvecoForm'],
});


const LandingPageModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "LandingPageModule" */ '../components/LandingPageModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['LandingPageModule'],
});


const Layout = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Layout" */ '../components/Layout').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Layout'],
});


const Legend = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Legend" */ '../components/Legend').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Legend'],
});


const LogoWall = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "LogoWall" */ '../components/LogoWall').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['LogoWall'],
});


const MapContainer = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "MapContainer" */ '../components/MapContainer').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['MapContainer'],
});


const NewsletterFormModalPopup = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "NewsletterFormModalPopup" */ '../components/NewsletterFormModalPopup').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['NewsletterFormModalPopup'],
});


const NumbersNeedsToFix = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "NumbersNeedsToFix" */ '../components/NumbersNeedsToFix').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['NumbersNeedsToFix'],
});


const OilDistributionMap = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "OilDistributionMap" */ '../components/OilDistributionMap').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['OilDistributionMap'],
});


const OilsAndCoolants = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "OilsAndCoolants" */ '../components/OilsAndCoolants').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['OilsAndCoolants'],
});


const OilsFilter = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "OilsFilter" */ '../components/OilsFilter').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['OilsFilter'],
});


const OriginalIsBetter = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "OriginalIsBetter" */ '../components/OriginalIsBetter').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['OriginalIsBetter'],
});


const PageAboutUs = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PageAboutUs" */ '../components/PageAboutUs').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PageAboutUs'],
});


const PageCategory = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PageCategory" */ '../components/PageCategory').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PageCategory'],
});


const PageNewsletter = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PageNewsletter" */ '../components/PageNewsletter').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PageNewsletter'],
});


const PageProduct = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PageProduct" */ '../components/PageProduct').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PageProduct'],
});


const Pager = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Pager" */ '../components/Pager').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Pager'],
});


const PageTitleModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PageTitleModule" */ '../components/PageTitleModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PageTitleModule'],
});


const PassionGuideSlider = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PassionGuideSlider" */ '../components/PassionGuideSlider').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PassionGuideSlider'],
});


const PerformanceAndDimensionsModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PerformanceAndDimensionsModule" */ '../components/PerformanceAndDimensionsModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PerformanceAndDimensionsModule'],
});


const PopUp = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PopUp" */ '../components/PopUp').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PopUp'],
});


const PressRelease = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "PressRelease" */ '../components/PressRelease').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['PressRelease'],
});


const Pulse = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Pulse" */ '../components/Pulse').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Pulse'],
});


const Quote = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Quote" */ '../components/Quote').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Quote'],
});


const RelatedGenuinePartsByCategoryResolver = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "RelatedGenuinePartsByCategoryResolver" */ '../components/RelatedGenuinePartsByCategoryResolver').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['RelatedGenuinePartsByCategoryResolver'],
});


const RelatedStories = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "RelatedStories" */ '../components/RelatedStories').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['RelatedStories'],
});


const RelatedStoriesByCategory = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "RelatedStoriesByCategory" */ '../components/RelatedStoriesByCategory').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['RelatedStoriesByCategory'],
});


const Search = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Search" */ '../components/Search').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Search'],
});


const SearchResults = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SearchResults" */ '../components/SearchResults').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SearchResults'],
});


const SetsOfBenefitIcons = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SetsOfBenefitIcons" */ '../components/SetsOfBenefitIcons').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SetsOfBenefitIcons'],
});


const Share = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Share" */ '../components/Share').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Share'],
});


const Slider = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Slider" */ '../components/Slider').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Slider'],
});


const SparePartsFinder = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SparePartsFinder" */ '../components/SparePartsFinder').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SparePartsFinder'],
});


const SplitCarousel = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SplitCarousel" */ '../components/SplitCarousel').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SplitCarousel'],
});


const SpotifyModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SpotifyModule" */ '../components/SpotifyModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SpotifyModule'],
});


const SPTextImageModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "SPTextImageModule" */ '../components/SPTextImageModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['SPTextImageModule'],
});


const Stage = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Stage" */ '../components/Stage').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Stage'],
});


const Stage360Preview = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Stage360Preview" */ '../components/Stage360Preview').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Stage360Preview'],
});


const StoryBanner = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "StoryBanner" */ '../components/StoryBanner').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['StoryBanner'],
});


const StoryCardList = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "StoryCardList" */ '../components/StoryCardList').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['StoryCardList'],
});


const Tabs = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Tabs" */ '../components/Tabs').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Tabs'],
});


const TabWithMap = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TabWithMap" */ '../components/TabWithMap').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TabWithMap'],
});


const Technologies = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "Technologies" */ '../components/Technologies').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['Technologies'],
});


const TechnologyMap = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TechnologyMap" */ '../components/TechnologyMap').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TechnologyMap'],
});


const TextImageModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextImageModule" */ '../components/TextImageModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextImageModule'],
});


const TextImageTextModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextImageTextModule" */ '../components/TextImageTextModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextImageTextModule'],
});


const TextLinksModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextLinksModule" */ '../components/TextLinksModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextLinksModule'],
});


const TextModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextModule" */ '../components/TextModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextModule'],
});


const TextNumberModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextNumberModule" */ '../components/TextNumberModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextNumberModule'],
});


const TextVideoModule = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TextVideoModule" */ '../components/TextVideoModule').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TextVideoModule'],
});


const TransmissionCards = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TransmissionCards" */ '../components/TransmissionCards').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TransmissionCards'],
});


const TwoValuesNumbers = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "TwoValuesNumbers" */ '../components/TwoValuesNumbers').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['TwoValuesNumbers'],
});


const VideoInterview = Loadable({
	loader: () => {
		signalComponentLoad();
		return import(/* webpackChunkName: "VideoInterview" */ '../components/VideoInterview').then(C => {
			signalComponentLoaded();
			return C as any;
		});
	},
	loading: () => <div>Loading...</div>,
	modules: ['VideoInterview'],
});


function signalComponentLoad() {
	if (typeof window !== 'undefined') {
		if (window.componentsLoading == undefined) {
			window.componentsLoading = 0;
		} else {
			window.componentsLoading++;
		}
	}
}

function signalComponentLoaded() {
	if (typeof window !== 'undefined') {
		if (window.componentsLoading) {
			window.componentsLoading--;

			if (window.componentsLoading === 0) {
				window.dispatchEvent(new Event('componentsLoaded'));
			}
		}
	}
}

const components = new Map();
components.set('Accordion', Accordion);
components.set('AlwaysInMotion', AlwaysInMotion);
components.set('AnchorBar', AnchorBar);
components.set('ApplicationLegend', ApplicationLegend);
components.set('AppointmentFormModalPopup', AppointmentFormModalPopup);
components.set('AxleCards', AxleCards);
components.set('AxleCardsContainer', AxleCardsContainer);
components.set('Banner', Banner);
components.set('BannerWithAnimatedLeftSide', BannerWithAnimatedLeftSide);
components.set('BannerWithCards', BannerWithCards);
components.set('Breadcrumb', Breadcrumb);
components.set('CallUsList', CallUsList);
components.set('CardCompare', CardCompare);
components.set('CardContainer', CardContainer);
components.set('CardList', CardList);
components.set('CardProductWrapper', CardProductWrapper);
components.set('CardsPress', CardsPress);
components.set('Carousel', Carousel);
components.set('CarouselLazy', CarouselLazy);
components.set('Collaboration Slider', CollaborationSlider);
components.set('ContactModule', ContactModule);
components.set('ContactUsFormModalPopup', ContactUsFormModalPopup);
components.set('ContactUsTemplate', ContactUsTemplate);
components.set('CtaList', CtaList);
components.set('CustomSelect', CustomSelect);
components.set('CxContactUs', CxContactUs);
components.set('CxFormContainerModule', CxFormContainerModule);
components.set('CxSlider', CxSlider);
components.set('DealerLocatorChineseModule', DealerLocatorChineseModule);
components.set('DealerLocatorModule', DealerLocatorModule);
components.set('DescriptionWithSpecificationHighlights', DescriptionWithSpecificationHighlights);
components.set('Details', Details);
components.set('DoubleCtaList', DoubleCtaList);
components.set('DynamicCard', DynamicCard);
components.set('DynamicCardList', DynamicCardList);
components.set('EAxleModelContainer', EAxleModelContainer);
components.set('eAxleStage360Preview', eAxleStage360Preview);
components.set('EditorialView', EditorialView);
components.set('EDrivelinesSolutions', EDrivelinesSolutions);
components.set('EngineModelCards', EngineModelCards);
components.set('EngineSeries', EngineSeries);
components.set('FAQ', FAQ);
components.set('Filter', Filter);
components.set('Filter.new', Filternew);
components.set('FilterDetailPageStage', FilterDetailPageStage);
components.set('FindEngineTemplate', FindEngineTemplate);
components.set('FindYourEngine', FindYourEngine);
components.set('Footer', Footer);
components.set('Form', Form);
components.set('FormContainerModule', FormContainerModule);
components.set('GlobalPresenceNumbers', GlobalPresenceNumbers);
components.set('Header', Header);
components.set('HeaderOld', HeaderOld);
components.set('HeroBanner', HeroBanner);
components.set('History', History);
components.set('Homepage', Homepage);
components.set('Hotspot', Hotspot);
components.set('IconList', IconList);
components.set('Icons', Icons);
components.set('IFrameModule', IFrameModule);
components.set('ImageCtaList', ImageCtaList);
components.set('ImageGallery', ImageGallery);
components.set('InfiniteScroll', InfiniteScroll);
components.set('InnovationContainer', InnovationContainer);
components.set('IvecoForm', IvecoForm);
components.set('LandingPageModule', LandingPageModule);
components.set('Layout', Layout);
components.set('Legend', Legend);
components.set('LogoWall', LogoWall);
components.set('MapContainer', MapContainer);
components.set('NewsletterFormModalPopup', NewsletterFormModalPopup);
components.set('NumbersNeedsToFix', NumbersNeedsToFix);
components.set('OilDistributionMap', OilDistributionMap);
components.set('OilsAndCoolants', OilsAndCoolants);
components.set('OilsFilter', OilsFilter);
components.set('OriginalIsBetter', OriginalIsBetter);
components.set('PageAboutUs', PageAboutUs);
components.set('PageCategory', PageCategory);
components.set('PageNewsletter', PageNewsletter);
components.set('PageProduct', PageProduct);
components.set('Pager', Pager);
components.set('PageTitleModule', PageTitleModule);
components.set('PassionGuideSlider', PassionGuideSlider);
components.set('PerformanceAndDimensionsModule', PerformanceAndDimensionsModule);
components.set('PopUp', PopUp);
components.set('PressRelease', PressRelease);
components.set('Pulse', Pulse);
components.set('Quote', Quote);
components.set('RelatedGenuinePartsByCategoryResolver', RelatedGenuinePartsByCategoryResolver);
components.set('RelatedStories', RelatedStories);
components.set('RelatedStoriesByCategory', RelatedStoriesByCategory);
components.set('Search', Search);
components.set('SearchResults', SearchResults);
components.set('SetsOfBenefitIcons', SetsOfBenefitIcons);
components.set('Share', Share);
components.set('Slider', Slider);
components.set('SparePartsFinder', SparePartsFinder);
components.set('SplitCarousel', SplitCarousel);
components.set('SpotifyModule', SpotifyModule);
components.set('SPTextImageModule', SPTextImageModule);
components.set('Stage', Stage);
components.set('Stage360Preview', Stage360Preview);
components.set('StoryBanner', StoryBanner);
components.set('StoryCardList', StoryCardList);
components.set('Tabs', Tabs);
components.set('TabWithMap', TabWithMap);
components.set('Technologies', Technologies);
components.set('TechnologyMap', TechnologyMap);
components.set('TextImageModule', TextImageModule);
components.set('TextImageTextModule', TextImageTextModule);
components.set('TextLinksModule', TextLinksModule);
components.set('TextModule', TextModule);
components.set('TextNumberModule', TextNumberModule);
components.set('TextVideoModule', TextVideoModule);
components.set('TransmissionCards', TransmissionCards);
components.set('TwoValuesNumbers', TwoValuesNumbers);
components.set('VideoInterview', VideoInterview);

export default function componentFactory(componentName) {
  return components.get(componentName);
};

declare global {
  interface Window {
    componentsLoading?: number;
  }
}
